/**
 * Light / dark toggle (the buttons rendered by snippets/theme-toggle.liquid).
 *
 * The theme itself is applied by an inline script in layout/theme.liquid,
 * BEFORE the stylesheet and before first paint. This file only handles the
 * buttons: reading the current state, flipping it, and remembering the choice.
 *
 * Splitting it that way is the whole point. A deferred script setting the
 * theme would render the page light and then repaint it dark - a flash worse
 * than having no dark mode at all - and a toggle inlined in the head would
 * block parsing for something nobody has clicked yet.
 */
(function () {
  var STORAGE_KEY = 'glide-theme';
  var root = document.documentElement;
  var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  /* What the visitor is actually looking at right now, which is not the same
     as what is stored: with nothing stored the page is following the
     operating system, and the button still has to show the right state. */
  function currentTheme() {
    var explicit = root.getAttribute('data-theme');
    if (explicit === 'dark' || explicit === 'light') return explicit;
    return mediaQuery.matches ? 'dark' : 'light';
  }

  function apply(theme, buttons) {
    root.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* Private mode. The choice will not survive the visit, but it still
         works for this one, so there is nothing to tell the visitor. */
    }
    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
  }

  function init() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-theme-toggle]'));
    if (buttons.length === 0) return;

    buttons.forEach(function (button) {
      button.setAttribute('aria-pressed', currentTheme() === 'dark' ? 'true' : 'false');
      button.addEventListener('click', function () {
        apply(currentTheme() === 'dark' ? 'light' : 'dark', buttons);
      });
    });

    /* Follow the OS while the visitor has expressed no preference of their
       own. Once they have chosen, their choice outranks the system - changing
       it under them because the sun went down would be the wrong call. */
    mediaQuery.addEventListener('change', function () {
      var stored = null;
      try {
        stored = localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        /* Treated as no preference, which is the safe reading. */
      }
      if (stored === 'dark' || stored === 'light') return;
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', mediaQuery.matches ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
